module.exports = __webpack_public_path__ + "img/bg-form-lower-desktop.3beb9b0f.png";